import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import Header from './components/Header';
import Post from './components/Post';
import Get from './components/Get';
import color from './components/color';

const AddMoney = () => {
  const navigate = useNavigate();

  const [amount, setAmount] = useState('');
  const [user, setUser] = useState(null);
  const [setting, setSetting] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedSetting = localStorage.getItem('setting');

    if (storedUser) setUser(JSON.parse(storedUser));
    if (storedSetting) setSetting(JSON.parse(storedSetting).add_money);
  }, []);

  const sendMessage = message => {
    Get.SendMessage(message);
  };

  const handleAdd = () => {
    if (!amount || parseFloat(amount) < (setting?.min_amount || 0)) {
      alert(`Amount should be greater than or equal to ${setting?.min_amount}`);
      return;
    }
    navigate('/qr', {state: {amount}});
  };

  const handleSubmit = async () => {
    setLoading(true);
    const data = {amount};
    try {
      const res = await Post.AddMoney(data);
      setLoading(false);
      if (res.success) {
        sendMessage(`${user.name} added money successfully, amount ${amount}`);
        alert('Your Add Money Request has been sent');
        setAmount('');
      } else {
        alert(res.errorMsg);
      }
    } catch (error) {
      setLoading(false);
      alert('Something went wrong');
    }
  };

  return (
    <>
      <Header title="Add Money" />
      <div style={styles.container}>
        <div style={styles.card}>
          <h3 style={styles.title}>UPI 24x7</h3>
          <div style={styles.formGroup}>
            <label style={styles.label}>Amount</label>
            <input
              type="number"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              placeholder="Enter amount"
              style={styles.input}
            />
          </div>
          <button
            style={styles.playbutton}
            onClick={handleAdd}
            disabled={loading}>
            {loading ? 'Loading...' : 'Add Money'}
          </button>
        </div>

        {setting && <div style={styles.alert}>{setting.text}</div>}
      </div>
    </>
  );
};

export default AddMoney;

const styles = {
  container: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  card: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: '15px',
    fontSize: '18px',
    color: '#333',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
  },
  label: {
    marginBottom: '5px',
    fontSize: '14px',
    color: '#555',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '10px',
  },
  alert: {
    marginTop: '20px',
    padding: '10px',
    borderRadius: '6px',
    backgroundColor: '#f8d7da',
    color: '#721c24',
    border: '1px solid #f5c6cb',
    fontSize: '14px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '400px',
  },
  playbutton: {
    backgroundColor: '#1b4ca7',
    width: '100%',
    padding: '10px',
    border: 'none',
    borderRadius: '6px',
    color: '#fff',
  },
};
